import React, { useEffect, useState } from 'react'

import {
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    Typography,
} from '@material-ui/core'

import { useSelector } from 'react-redux'
import { selectUsuarioSeleccionado } from '../../../redux/reducer/loginReducer'
import { tutores_pagos, tutores_pagos_materiales_update_importe } from '../../../services/alumnos'

const DialogModalConfigPagoTutores = ({ openModal, setOpenModal }) => {
    const usuarioSeleccionado = useSelector(state => selectUsuarioSeleccionado(state))

    const [tutores, setTutores] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!openModal) return

        setLoading(true)
        tutores_pagos({ usuario_id: usuarioSeleccionado.id }).then(response => {
            setTutores(response?.tutores ?? [])
            setLoading(false)
        })
    }, [openModal, usuarioSeleccionado.id])

    const handleChangeImporte = (id, campo, valor) => {
        setTutores(prev =>
            prev.map(t => t.id === id ? { ...t, [campo]: valor } : t)
        )
    }

    const handleBlurImporte = (tutor) => {
        tutores_pagos_materiales_update_importe({
            usuario_id: usuarioSeleccionado.id,
            tutor_usuario_id: tutor.id,
            importe_material: tutor.importe_material,
            importe_alumno: tutor.importe_alumno,
        })
    }

    return (
        <Dialog
            open={openModal}
            onClose={() => setOpenModal(false)}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>Configurar pago materiales</DialogTitle>
            <DialogContent style={{ minHeight: '200px' }}>
                {loading ? (
                    <Grid container justifyContent="center" style={{ padding: 40 }}>
                        <CircularProgress />
                    </Grid>
                ) : (
                    <Grid container spacing={2} style={{ paddingTop: 8, paddingBottom: 16 }}>

                        <Grid item xs={12}>
                            <Grid container spacing={1} style={{ paddingBottom: 4 }}>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle2" color="textSecondary">
                                        Tutor
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle2" color="textSecondary">
                                        Grupos tutoría
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle2" color="textSecondary">
                                        Importe materiales (€)
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle2" color="textSecondary">
                                        Importe por alumno (€)
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        {tutores.length === 0 && (
                            <Grid item xs={12}>
                                <Typography color="textSecondary">No hay tutores disponibles.</Typography>
                            </Grid>
                        )}

                        {tutores.map(tutor => (
                            <Grid item xs={12} key={tutor.id}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={3}>
                                        <Typography variant="body2">
                                            {`${tutor.nombre_completo ?? ''}`.trim()}
                                            {tutor.es_tutor === 1 && <span style={{ marginLeft: 6, color: '#1976d2', fontWeight: 600 }}>(T)</span>}
                                            {tutor.es_creador === 1 && <span style={{ marginLeft: 6, color: '#388e3c', fontWeight: 600 }}>(C)</span>}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography variant="body2">{tutor.grupos_tutoria ?? ''}</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            type="number"
                                            value={tutor.importe_material ?? ''}
                                            onChange={e => handleChangeImporte(tutor.id, 'importe_material', e.target.value)}
                                            onBlur={() => handleBlurImporte(tutor)}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            inputProps={{ min: 0, step: '0.01' }}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            type="number"
                                            value={tutor.importe_alumno ?? ''}
                                            onChange={e => handleChangeImporte(tutor.id, 'importe_alumno', e.target.value)}
                                            onBlur={() => handleBlurImporte(tutor)}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            inputProps={{ min: 0, step: '0.01' }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}

                    </Grid>
                )}
            </DialogContent>
        </Dialog>
    )
}

export default DialogModalConfigPagoTutores
